export const replaceSpacesWithDashes = x => x.replace(/ /g, '-').toLowerCase()
